import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './modules/layout/layout.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { KeycloakAngularModule } from 'keycloak-angular';
import { initializer } from './core/init/auth.init';
import { LoggerModule } from 'ngx-logger';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { configLogger } from './core/init/config-logger';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenServiceInterceptor } from './core/interceptors/token.interceptor';

/**
 * @description defaultGTMKey
 * @returns ktgm on LocalStorage
 */
const defaultGTMKey: () => string = (): string => {
  // localStorage.setItem('kgtm', environment.GTM_KEY);
  const result: string = localStorage.getItem('kgtm');
  return result;
};
/**
 * @description modulos, servicios y componentes de la app
 */
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    KeycloakAngularModule,
    SharedModule,
    AppRoutingModule,
    LayoutModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    LoggerModule.forRoot(configLogger())
  ],
  providers: [GoogleTagManagerService, { provide: 'googleTagManagerId', useValue: defaultGTMKey() },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true
    },
    {provide: HTTP_INTERCEPTORS   , useClass: TokenServiceInterceptor, multi: true}
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {
}
